import {Component, inject} from '@angular/core';
import {AsyncPipe} from '@angular/common';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {NgApexchartsModule} from 'ng-apexcharts';
import {LineChartSettingsService} from '../line-chart.settings.service';
import {ReferralsSubmittedSeriesService} from './referrals-submitted-series.service';

@Component({
  selector: 'app-referrals-submitted-chart',
  templateUrl: './referrals-submitted-chart.component.html',
  styleUrls: ['./referrals-submitted-chart.component.scss'],
  standalone: true,
  imports: [AsyncPipe, NgApexchartsModule, MatProgressSpinnerModule],
})
export class ReferralsSubmittedChartComponent {
  referralsSubmittedSeriesService = inject(ReferralsSubmittedSeriesService);
  settings = inject(LineChartSettingsService);

  constructor() {
    this.settings = Object.assign(
      {},
      this.settings
        .configureYAxisTitle('Referrals')
        .configureYAxisMin((min) => {
          return 0;
        })
        .configureTooltip((val: number, opts?: any): string => {
          if (val === null || val === undefined) return 'No Data';
          return `${val} referrals`;
        })
    );
  }
}
